<template>
  <v-dialog :model-value="dialog" @update:model-value="$emit('update:dialog', $event)" max-width="600px">
    <v-card>
      <v-card-title class="d-flex justify-space-between align-center">
        <span class="text-h5">Agregar nuevo miembro</span>
        <v-btn icon @click="closeWindow">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text>
        <v-container>
          <v-row>
            <v-col cols="12">
              <v-text-field
                v-model="email"
                label="Correo electrónico"
                placeholder="example@usach.cl"
                outlined
                hide-details="auto"
                @keyup.enter="addUser"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <v-alert type="info" dense>
                Si el usuario no existe, se crea con la contraseña "password"
              </v-alert>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" @click="addUser">Agregar</v-btn>
        <v-btn text @click="closeWindow">Cancelar</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>

  <v-snackbar
    v-model="snackbar"
    :color="snackbarColor"
    top
    timeout="3000"
  >
    {{ snackbarText }}
  </v-snackbar>
</template>

<script>
import api from '@/api.js';
export default {
  name: "NewMemberComponent",
  props: {
    dialog: Boolean,
    projectId: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      email: "",
    };
  },
  methods: {
    closeWindow() {
      this.$emit("update:dialog", false);
    },
    async addUser() {
      // Verificar que el email exista
      if (!this.email) {
        this.$store.commit(
          'setSnackbar', 
          {
            text: 'Debe ingresar un correo electrónico', 
            color: 'red',
            icon: 'mdi-alert'
          }
        );
        return;
      }

      // Verificar que el email sea de la USACH
      if (!this.email.includes("@usach.cl")) {
        this.$store.commit(
          'setSnackbar', 
          {
            text: 'El correo debe ser @usach.cl', 
            color: 'red',
            icon: 'mdi-alert'
          }
        );
        return;
      }

      // TODO: verificar que el usuario no esté ya en el proyecto

      // Pedir usuario a backend por email
      var response;
      try {
        response = await api.get(
          `/api/user/perfil/email/${this.email}`,
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("token")}`,
            },
          }
        );

      } catch (e) {
        console.error(e);
        // this.showSnackbar("Error al buscar usuario", "error");
        return;
      }

      // Si no existe, registrarlo en el sistema
      if (!response.data) {
        // Crear el usuario
        const user = {
          email: this.email,
          password: "password",
          name: this.email.split("@")[0]
            .split(".")[0]
            .charAt(0).toUpperCase() + this.email.split("@")[0]
            .split(".")[0].slice(1),
          lastname: this.email.split("@")[0]
          .split(".")[1]
          ? this.email.split("@")[0]
            .split(".")[1]
            .charAt(0).toUpperCase() + this.email.split("@")[0]
            .split(".")[1].slice(1)
          : "",
          role: "user",
        };

        // Mandarlo a backend
        try {
          response = await api.post(
            `/api/auth/signup`,
            user,
            {
              headers: {
                Authorization: `Bearer ${localStorage.getItem("token")}`,
              },
            }
          );
          console.log(response);

          if(response.status == 201){
            this.$store.commit(
              'setSnackbar', 
              {
                text: 'Usuario creado correctamente', 
                color: 'success',
                icon: 'mdi-check-circle'
              }
            );
          }
        }catch(e){
          console.error(e);
          this.$store.commit(
            'setSnackbar', 
            {
              text: 'Error al crear usuario', 
              color: 'red',
              icon: 'mdi-alert'
            }
          );
          return;
        }
      }
      
      // Finalmente, agregamos el correo al proyecto
      try {
        response = await api.post(`/api/project/${this.$route.params.projectId}/add/member/${this.email}`);
        this.email = "";
        this.$store.commit(
          'setSnackbar', 
          {
            text: 'Usuario agregado!', 
            color: 'success',
            icon: 'mdi-check-circle'
          }
        );
      } catch (e) {
        console.error(e);
        this.$store.commit(
          'setSnackbar', 
          {
            text: 'Error al agregar usuario', 
            color: 'red',
            icon: 'mdi-alert'
          }
        );
        return;
      }
    },
  },
  created(){
    console.log("NewMemberComponent created");
  }
};
</script>

<style scoped>
/* No se necesitan estilos adicionales ya que usamos los componentes de Vuetify */
</style>
